module.exports = __webpack_public_path__ + "img/g.c31da085.jpg";